// /uprising — The Uprising · Backstage Pass
// Thin wrapper on the shared VerticalCockpit chassis.
// Skin: stage lighting — spotlight gold + stage crimson.
import VerticalCockpit from "@/components/VerticalCockpit";
import { PALETTES } from "@/config/AssetSpine";
import { VERTICAL_CONFIG } from "@/config/verticalConfig";

export default function Uprising() {
  return (
    <VerticalCockpit
      config={VERTICAL_CONFIG.MUSIC}
      palette={PALETTES.MUSIC}
      testPrefix="up"
    />
  );
}
